import React from 'react';
import ReportingGivingByFundPage from '../components/ReportingGivingByFundPage';

const ReportingGivingByFundApp = (props) => (
  <ReportingGivingByFundPage {...props} />
);

export default ReportingGivingByFundApp;
